import scroll_magic_animation from "../../js/src/scroll-magic";
import slick_slider from "../../js/src/slick-sliders";

class media_carousel {
    media_carousel_config = {
        settings: {
            v_landscape: {
                dots: true,
                arrows: false,
                infinite: true,
                speed: 300,
                slidesToShow: 2,
                adaptiveHeight: true,
                appendDots: null,
                variableWidth: false,
                focusOnSelect: true,
                responsive: [
                    {
                        breakpoint: 768,
                        settings: {
                            slidesToShow: 1,
                            variableWidth: true
                        }
                    }
                ]
            },
            v_portrait: {
                dots: true,
                arrows: false,
                infinite: true,
                speed: 300,
                slidesToShow: 4,
                adaptiveHeight: true,
                appendDots: null,
                variableWidth: false,
                focusOnSelect: true,
                responsive: [
                    {
                        breakpoint: 1528,
                        settings: {
                            slidesToShow: 3,
                            variableWidth: true
                        }
                    },
                    {
                        breakpoint: 1025,
                        settings: {
                            slidesToShow: 2,
                            variableWidth: true
                        }
                    }
                ]
            },
            i_portrait: {
                dots: true,
                arrows: false,
                infinite: true,
                speed: 300,
                slidesToShow: 4,
                adaptiveHeight: true,
                appendDots: null,
                variableWidth: false,
                responsive: [
                    {
                        breakpoint: 1528,
                        settings: {
                            slidesToShow: 3,
                            variableWidth: true
                        }
                    },
                    {
                        breakpoint: 1025,
                        settings: {
                            slidesToShow: 2,
                            variableWidth: true
                        }
                    }
                ]
            },
            i_landscape: {
                dots: true,
                arrows: false,
                infinite: true,
                speed: 300,
                slidesToShow: 2,
                adaptiveHeight: true,
                appendDots: null,
                variableWidth: false,
                focusOnSelect: true,
                responsive: [
                    {
                        breakpoint: 768,
                        settings: {
                            slidesToShow: 1,
                            variableWidth: true
                        }
                    }
                ]
            }
        },
        sliders: [],
        players: [],
        videos: []
    }

    constructor() {
        this.media_carousel_slider_init();
        this.media_carousel_video_init();
    }

    media_carousel_slider_init() {
        // Set global context outside of loop
        let _t = this;

        $('[block-name="media-carousel"]').each(function(i, e) {
            // Set slider config
            let media_carousel_config = ($(e).data('content-type') === 'video')
                ? ($(e).data('image-type') === 'portrait' ? _t.media_carousel_config.settings.v_portrait : _t.media_carousel_config.settings.v_landscape)
                : ($(e).data('image-type') === 'portrait' ? _t.media_carousel_config.settings.i_portrait : _t.media_carousel_config.settings.i_landscape);

            // Set slider element per block
            let $media_carousel_slider = $(e).find('.media-carousel__slider');

            _t.media_carousel_config.sliders.push($media_carousel_slider);

            // Bind animation to card carousel
            let $media_carousel_animation = new scroll_magic_animation($media_carousel_slider, 'animate--slide-right--double');

            // Bind dots to slick dots component
            let $media_carousel_dots = $(e).find('.slick-slider__dots');

            // Bind card carousel dots to sick element
            media_carousel_config.appendDots = $media_carousel_dots;

            var numItems = $(e).data("length");
            var config = _t.media_carousel_config.settings.v_portrait;

            config.focusOnSelect = !(numItems < 5 && $(e).data("image-type") === 'portrait' && $(e).data("contentType") === 'video');

            // Init Cards Carousel Slider
            let media_carousel = new slick_slider($media_carousel_slider, null, media_carousel_config);

            // Bind media carousel event handlers
            _t.media_carousel_bind_events();
        });
    }

    video_toggle(status, video, button){
        if(status){
            // Mute video to allow for click to play
            video.mute();
            // Play video
            video.playVideo();
            // Fade out video cover
            button.fadeOut();
        } else {
            // Reset video back to start
            video.seekTo(0, false);
            // Pause video
            video.pauseVideo();
            // Reset video back to start
            video.stopVideo();
            // Fade in video cover
            button.fadeIn();
        }
    }

    media_carousel_video_init() {
        // Set global context outside of loop
        let _t = this;

        // Create YouTube Iframe API Script
        var youtube_script = $('<script>')
            .attr('type', 'text/javascript')
            .attr('src', 'https://www.youtube.com/iframe_api');

        $('head').append(youtube_script);

        // Loop through each slide and build video array with iframes and play button
        $('[block-name="media-carousel"]').find('.slick-slide:not(.slick-cloned)').each(function(i, e) {
            $(e).find('iframe').attr('id', 'video-' + i);

            // Check if id has been set for iframe before populating video variable
            if($(e).find('iframe').attr('id')) {
                let video = {
                    id: $(e).find('iframe').attr('id'),
                    button: $(e).find('.mc-button')
                }

                _t.media_carousel_config.videos.push(video);
            }
        });

        // YouTube Embed API Callback function when scripts are initalized
        window.onYouTubeIframeAPIReady = () => {
            // Loop through each iframe and initalize youtube api
            $.each(_t.media_carousel_config.videos, function(index, video) {
                _t.media_carousel_config.players.push(new YT.Player(video.id, {
                    playerVars: {
                        'playsinline': 1
                    },
                    events: {
                        'onReady': (event) => {
                            // Bind media carousel event handlers once videos are initalized
                            _t.media_carousel_bind_events();

                            video.button.on('click', function() {
                                _t.video_toggle(true, event.target, video.button);
                            });
                        },
                        'onStateChange': (event) => {
                            // Reset video on end
                            if(event.data === 0) _t.video_toggle(false, event.target, video.button);
                        }
                    }
                }));
            });
        }
    }

    media_carousel_bind_events(){
        // Set global context outside of loop
        let _t = this;

        $.each(_t.media_carousel_config.sliders, function(i,slider){
            // Set prev and next slick controls per block
            let $slide_prev = $(slider).parent().find('.slick-slider__navigation--prev');
            let $slide_next = $(slider).parent().find('.slick-slider__navigation--next');

            // Bind previous control to all sliders
            $slide_prev.on('click', function() {
                $(slider).slick('slickPrev');
                $(slider).slick('slickPrev');
            });

            // Bind next control to all sliders
            $slide_next.on('click', function() {
                $(slider).slick('slickNext');
                $(slider).slick('slickNext');
            });

            // If slide changes then reset active video and slide
            $(slider).on('beforeChange', function(){
                let players = _t.media_carousel_config.players;

                // Check if player has been initalized
                if(players){
                    // Loop through each player and check if current time is larger then 0
                    $.each(players, function(i,player){
                        // Reset video if larger than 0
                        if(player.getCurrentTime() > 0){
                            _t.video_toggle(false, player, $('#video-'+i).next());
                        }
                    });
                }
            });
        });
    }
}

$(() => {
    if($('[block-name="media-carousel"]').length) {
        let media_carousel_block = new media_carousel();
    }
});
